module.exports = __webpack_public_path__ + "media/images/lesson_5/sebastiao_saltitao_large-1d3277d3b6c64c9505bad1aa8068b281.png";